import React, { useState, useEffect } from "react";
import { oneKlicks } from "../../../../SDK/oneclick";
import { useParams } from "react-router-dom";
import { decryptId } from "../../../../services/apiService";
import DynamicBreadcrumbs from "../../../../Uitiles/DynamicBreadcrumbs";
import { toast } from "react-toastify";

const ArticlesReviews = () => {
    const [article, setArticle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [reviews, setReviews] = useState([]);
    const [relatedArticles, setRelatedArticles] = useState([]);
    const [showReviewForm, setShowReviewForm] = useState(false);
    const [newReview, setNewReview] = useState({
        comment: '',
        rating: 5,
        parent_id: null,
        name: '',
        email: '',
        phone: ''
    });
    const [replyTo, setReplyTo] = useState(null);
    const { slug, id } = useParams();
    const decryptedId = decryptId(id);

    useEffect(() => {
        fetchArticle();
        fetchReviews();
    }, []);

    useEffect(() => {
        if (article?.categories?.id) {
            fetchRelatedArticles();
        }
    }, [article]);

    const fetchArticle = async () => {
        try {
            const conditions = {
                id: decryptedId,
            };
            const response = await oneKlicks.read(
                "articles",
                "articles",
                conditions,
                "created_at DESC",
                {},
                {},
                [
                    {
                        target_table: "users",
                        target_column: "id",
                        target_value: "doctor_id",
                        target_label: "doctors"
                    },
                    {
                        target_table: "specialities",
                        target_column: "id",
                        target_value: "categories",
                        target_label: "categories"
                    }
                ]
            );
            if (response.data && response.data.length > 0) {
                const articleData = response.data[0];
                if (typeof articleData.tags === 'string') {
                    try {
                        articleData.tags = JSON.parse(articleData.tags);
                    } catch (e) {
                        console.error("Error parsing tags:", e);
                        articleData.tags = [];
                    }
                }
                setArticle(articleData);
            }
        } catch (error) {
            console.error("Error fetching article:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchReviews = async () => {
        try {
            const conditions = {
                article_id: decryptedId,
                status: "approved",

            };
            const tableSchema = "";
            const tableName = "article_reviews";
            const orderBy = "created_at DESC";
            const search = {};
            const pagination = {};
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.data) {
                console.log(response.data);
                setReviews(response.data);
            }
        } catch (error) {
            console.error("Error fetching reviews:", error);
        }
    };

    const fetchRelatedArticles = async () => {
        try {
            const conditions = {
                categories: article.categories.id,
                status: "published",
                id: { $ne: decryptedId }
            };
            const response = await oneKlicks.read(
                "articles",
                "articles",
                conditions,
                "created_at DESC",
                {},
                { limit: 3 },
                [
                    {
                        target_table: "users",
                        target_column: "id",
                        target_value: "doctor_id",
                        target_label: "doctors"
                    },
                    {
                        target_table: "specialities",
                        target_column: "id",
                        target_value: "categories",
                        target_label: "categories"
                    }
                ]
            );
            console.log("Related articles response:", response);
            if (response.data) {
                setRelatedArticles(response.data);
            }
        } catch (error) {
            console.error("Error fetching related articles:", error);
        }
    };

    const handleReviewSubmit = async (e) => {
        e.preventDefault();
        try {
            const conditions = {};
            const tableSchema = "";
            const tableName = "article_reviews";

            const reviewData = {
                article_id: decryptedId,
                comment: newReview.comment,
                rating: newReview.rating,
                parent_id: newReview.parent_id,
                status: "pending",
                name: newReview.name,
                email: newReview.email,
                phone: newReview.phone
            };

            const response = await oneKlicks.create(tableSchema, tableName, reviewData, conditions);
            if (response.success) {
                setShowReviewForm(false);
                setNewReview({
                    comment: '',
                    rating: 5,
                    parent_id: null,
                    name: '',
                    email: '',
                    phone: ''
                });
                setReplyTo(null);
                fetchReviews(); // Refresh reviews
                toast.success("Review submitted successfully");
            } else {
                console.log(response);
                toast.error("Review submission failed");
            }
        } catch (error) {
            console.error("Error submitting review:", error);
        }
    };

    const handleReplyClick = (reviewId) => {
        setReplyTo(reviewId);
        setNewReview({ ...newReview, parent_id: reviewId });
        setShowReviewForm(true);
    };

    if (loading) {
        return <div>Loading article...</div>;
    }

    if (!article) {
        return <div>Article not found</div>;
    }

    return (
        <>
            <DynamicBreadcrumbs />
            <main id="dc-main" className="dc-main dc-haslayout">
                <div className="dc-haslayout dc-parent-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-8 col-xl-9 order-last">
                                <div className="dc-runner">
                                    <figure className="dc-runner-img">
                                        <img src={`${process.env.REACT_APP_API_BASE_URL}${article.featured_image}`} alt={article.title} />
                                    </figure>
                                    <div className="dc-runner-content">
                                        <div className="dc-catgories-wrap">
                                            <a className="" href={`/category/${article.categories?.name}`}>
                                                <span>{article.categories?.name}</span>
                                            </a>
                                        </div>
                                        <div className="dc-runner-heading">
                                            <h1>{article.title}</h1>
                                        </div>
                                        <ul className="d-flex flex-wrap justify-content-center align-items-center">
                                            <li className="mx-3">
                                                <i className="lnr lnr-clock"></i>
                                                {new Date(article.created_at).toLocaleDateString()}
                                            </li>
                                            <li className="dcget-likes mx-3" data-key={article.id}>
                                                <a href="javascript:;">
                                                    <i className="ti-heart"></i>{article.likes || 0} Likes
                                                </a>
                                            </li>
                                            <li className="mx-3">
                                                <i className="ti-eye"></i>{article.views || 0} Views
                                            </li>
                                            <li className="mx-3">
                                                <i className="ti-comment"></i>{article.comments || 0} Comments
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="dc-description">
                                    <div className="dc-para99">
                                        <div>
                                            <p className="dc-para">{article.content}</p>
                                            <div className="d-flex justify-content-around mx-auto dc-99-section flex-column flex-sm-row">
                                                <div className="align-self-center">
                                                    {/* <div className="dc-99icon-main">
                                                        <div className="dc-99icon">
                                                            <i className="ti-quote-right"></i>
                                                        </div>
                                                    </div> */}
                                                </div>
                                                {/* <div className="dc-99-content align-self-center pt-sm-0">
                                                    <em>{article.excerpt || "No excerpt available"}</em>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="dc-my-20 dc-card1">
                                    <div className="card-body d-flex dc-card-tags flex-column flex-xl-row">
                                        <ul className="d-flex dc-tags1 flex-wrap">
                                            <li>Tags</li>
                                            {article.tags && Array.isArray(article.tags) && article.tags.map((tag) => (
                                                <li key={tag}>
                                                    <a href={`/category/${tag}`} rel="tag">{tag}</a>
                                                </li>
                                            ))}
                                        </ul>

                                        <ul className="d-flex dc-tags-social">
                                            <li className="dc-sharejob">Share:</li>
                                            <li className="dc-fb">
                                                <a href={`//www.facebook.com/sharer.php?u=${window.location.href}`} target="_blank" rel="noopener noreferrer">
                                                    <i className="fab fa-facebook-f"></i>
                                                </a>
                                            </li>
                                            <li className="dc-twit">
                                                <a href={`//twitter.com/intent/tweet?text=${article.title}&url=${window.location.href}`} target="_blank" rel="noopener noreferrer">
                                                    <i className="fab fa-twitter"></i>
                                                </a>
                                            </li>
                                            <li className="dc-google-plus">
                                                <a href={`//plus.google.com/share?url=${window.location.href}`} target="_blank" rel="noopener noreferrer">
                                                    <i className="fab fa-google-plus-g"></i>
                                                </a>
                                            </li>
                                            <li className="dc-instg">
                                                <a href={`//pinterest.com/pin/create/button/?url=${window.location.href}&media=${process.env.REACT_APP_API_BASE_URL}${article.featured_image}&description=${article.title}`} target="_blank" rel="noopener noreferrer">
                                                    <i className="fab fa-pinterest-p"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                {/* Related Articles Section */}
                                <div className="dc-related-articles dc-my-20">
                                    <div className="dc-sectionhead">
                                        <h3>Related Articles</h3>
                                    </div>
                                    <div className="row">
                                        {relatedArticles.map((relatedArticle) => (
                                            <div key={relatedArticle.id} className="col-md-4">
                                                <div className="dc-card1 h-100">
                                                    <div className="card-body">
                                                        <figure className="dc-article-img mb-3">
                                                            <img
                                                                src={`${process.env.REACT_APP_API_BASE_URL}${relatedArticle.featured_image}`}
                                                                alt={relatedArticle.title}
                                                                className="img-fluid"
                                                            />
                                                        </figure>
                                                        <div className="dc-article-content">
                                                            <div className="dc-catgories-wrap mb-2">
                                                                <a href={`/category/${relatedArticle.categories?.name}`}>
                                                                    <span>{relatedArticle.categories?.name}</span>
                                                                </a>
                                                            </div>
                                                            <h4 className="mb-2">
                                                                <a href={`/article/${relatedArticle.slug}/${relatedArticle.id}`}>
                                                                    {relatedArticle.title}
                                                                </a>
                                                            </h4>
                                                            <div className="dc-article-meta">
                                                                <span className="dc-date">
                                                                    <i className="fa fa-calendar-alt mr-1"></i>
                                                                    {new Date(relatedArticle.created_at).toLocaleDateString()}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Reviews Section */}
                                <div className="dc-reviews-section dc-my-20">
                                    <div className="dc-sectionhead d-flex justify-content-between align-items-center mb-4">
                                        <h3 className="mb-0">Reviews ({reviews.length})</h3>
                                        <button
                                            className="dc-btn dc-btn-primary"
                                            onClick={() => {
                                                setShowReviewForm(true);
                                                setReplyTo(null);
                                                setNewReview({
                                                    comment: '',
                                                    rating: 5,
                                                    parent_id: null,
                                                    name: '',
                                                    email: '',
                                                    phone: ''
                                                });
                                            }}
                                            style={{ color: '#ffffff' }}
                                        >
                                            <i className="fa fa-comment mr-2"></i>Write a Review
                                        </button>
                                    </div>

                                    {/* Review Form Modal */}
                                    {showReviewForm && (
                                        <div className="dc-modal-overlay">
                                            <div className="dc-modal-content">
                                                <div className="dc-modal-header">
                                                    <h4 className="mb-0">{replyTo ? 'Reply to Review' : 'Write a Review'}</h4>
                                                    <button
                                                        className="dc-modal-close"
                                                        onClick={() => {
                                                            setShowReviewForm(false);
                                                            setReplyTo(null);
                                                            setNewReview({
                                                                comment: '',
                                                                rating: 5,
                                                                parent_id: null,
                                                                name: '',
                                                                email: '',
                                                                phone: ''
                                                            });
                                                        }}
                                                    >
                                                        <i className="fa fa-times"></i>
                                                    </button>
                                                </div>
                                                <form onSubmit={handleReviewSubmit} className="dc-review-form">
                                                    <div className="dc-form-group mb-4">
                                                        <label className="text-center d-block">Rating</label>
                                                        <div className="dc-rating-input justify-content-center">
                                                            {[1, 2, 3, 4, 5].map((star) => (
                                                                <i
                                                                    key={star}
                                                                    className={`fa fa-star ${star <= newReview.rating ? 'text-warning' : 'text-muted'}`}
                                                                    onClick={() => setNewReview({ ...newReview, rating: star })}
                                                                    style={{ cursor: 'pointer', fontSize: '28px', marginRight: '8px' }}
                                                                ></i>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    {!replyTo && (
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="dc-form-group">
                                                                    <label>Name *</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newReview.name}
                                                                        onChange={(e) => setNewReview({ ...newReview, name: e.target.value })}
                                                                        required
                                                                        placeholder="Enter your name"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="dc-form-group">
                                                                    <label>Email *</label>
                                                                    <input
                                                                        type="email"
                                                                        className="form-control"
                                                                        value={newReview.email}
                                                                        onChange={(e) => setNewReview({ ...newReview, email: e.target.value })}
                                                                        required
                                                                        placeholder="Enter your email"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <div className="dc-form-group">
                                                                    <label>Phone Number</label>
                                                                    <input
                                                                        type="tel"
                                                                        className="form-control"
                                                                        value={newReview.phone}
                                                                        onChange={(e) => setNewReview({ ...newReview, phone: e.target.value })}
                                                                        placeholder="Enter your phone number"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="dc-form-group">
                                                        <label>Comment *</label>
                                                        <textarea
                                                            className="form-control"
                                                            rows="4"
                                                            value={newReview.comment}
                                                            onChange={(e) => setNewReview({ ...newReview, comment: e.target.value })}
                                                            required
                                                            placeholder="Write your review here..."
                                                        ></textarea>
                                                    </div>
                                                    <div className="dc-form-group text-right">
                                                        <button type="button" className="dc-btn dc-btn-light mr-2" onClick={() => {
                                                            setShowReviewForm(false);
                                                            setReplyTo(null);
                                                            setNewReview({
                                                                comment: '',
                                                                rating: 5,
                                                                parent_id: null,
                                                                name: '',
                                                                email: '',
                                                                phone: ''
                                                            });
                                                        }}>
                                                            Cancel
                                                        </button>
                                                        <button type="submit" className="dc-btn dc-btn-primary" style={{ color: '#000000' }}>
                                                            Submit Review
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    )}

                                    {reviews.length > 0 ? (
                                        <div className="dc-reviews-list">
                                            {reviews.filter(review => !review.parent_id).map((review) => (
                                                <div key={review.id} className="dc-review-item dc-card1 mb-4">
                                                    <div className="card-body">
                                                        <div className="dc-review-header d-flex justify-content-between align-items-start mb-3">
                                                            <div className="dc-reviewer-info">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="dc-reviewer-avatar mr-3">
                                                                        <i className="fa fa-user-circle fa-2x text-primary"></i>
                                                                    </div>
                                                                    <div>
                                                                        <h4 className="mb-1">{review.name || review.users?.name || 'Anonymous'}</h4>
                                                                        <span className="dc-review-date text-muted">
                                                                            <i className="fa fa-calendar-alt mr-1"></i>
                                                                            {new Date(review.created_at).toLocaleDateString()}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {review.rating && (
                                                                <div className="dc-rating">
                                                                    {[...Array(5)].map((_, index) => (
                                                                        <i
                                                                            key={index}
                                                                            className={`fa fa-star ${index < review.rating ? 'text-warning' : 'text-muted'}`}
                                                                            style={{ fontSize: '18px' }}
                                                                        ></i>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="dc-review-content">
                                                            <p className="mb-0">{review.comment}</p>
                                                        </div>
                                                        <div className="dc-review-actions mt-3">
                                                            <button
                                                                className="dc-btn dc-btn-link"
                                                                onClick={() => handleReplyClick(review.id)}
                                                            >
                                                                <i className="fa fa-reply mr-1"></i> Reply
                                                            </button>
                                                        </div>

                                                        {/* Replies */}
                                                        {reviews.filter(reply => reply.parent_id === review.id).map((reply) => (
                                                            <div key={reply.id} className="dc-review-reply ml-4 mt-3">
                                                                <div className="dc-reviewer-info d-flex align-items-center mb-2">
                                                                    <div className="dc-reviewer-avatar mr-2">
                                                                        <i className="fa fa-user-circle text-primary"></i>
                                                                    </div>
                                                                    <div>
                                                                        <h5 className="mb-0">{reply.name || reply.users?.name || 'Anonymous'}</h5>
                                                                        <small className="text-muted">
                                                                            {new Date(reply.created_at).toLocaleDateString()}
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                                <p className="mb-0">{reply.comment}</p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="dc-no-reviews dc-card1">
                                            <div className="card-body text-center py-5">
                                                <i className="fa fa-comments fa-3x text-muted mb-3"></i>
                                                <h4>No Reviews Yet</h4>
                                                <p className="text-muted mb-0">Be the first to review this article!</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-md-8 col-lg-4 col-xl-3 order-first">
                                <aside id="dc-sidebar" className="dc-sidebar dc-sidebar-grid mt-lg-0">
                                    <div className="dc-widget dc-categories sidebar-box widget_search clr">
                                        <form className="dc-formtheme dc-formsearch" method="get" role="search">
                                            <fieldset>
                                                <div className="form-group">
                                                    <input type="search" name="s" className="form-control" placeholder="Searching might help" />
                                                    <button type="submit" className="dc-searchgbtn"><i className="fa fa-search"></i></button>
                                                </div>
                                            </fieldset>
                                        </form>
                                    </div>

                                    <div className="dc-widget dc-categories sidebar-box widget_categories clr">
                                        <div className="dc-widgettitle">
                                            <h3>Categories</h3>
                                        </div>
                                        <ul>
                                            <li className="cat-item cat-item-18">
                                                <a href="/anesthesiology">Anesthesiology</a>
                                            </li>
                                            <li className="cat-item cat-item-19">
                                                <a href="/dermatology">Dermatology</a>
                                            </li>
                                            <li className="cat-item cat-item-20">
                                                <a href="/diagnosticradiology">Diagnostic radiology</a>
                                            </li>
                                            <li className="cat-item cat-item-21">
                                                <a href="/emergencymedicine">Emergency medicine</a>
                                            </li>
                                            <li className="cat-item cat-item-22">
                                                <a href="/familymedicine">Family medicine</a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="dc-widget dc-categories sidebar-box dc-sidebaradds dc-searchresultad clr">
                                        <img src="//css.meddylist.com//wp-content/uploads/2019/08/img-02-4.jpg" alt="" />
                                    </div>

                                    <div className="dc-widget dc-categories sidebar-box widget_categories clr">
                                        <div className="dc-widgettitle">
                                            <h3>Popular Tags</h3>
                                        </div>
                                        <ul className="dc-tags">
                                            <li><a href="/tag/nephrology">Nephrology</a></li>
                                            <li><a href="/tag/subspecialty">Subspecialty</a></li>
                                            <li><a href="/tag/medicine">Medicine</a></li>
                                            <li><a href="/tag/health">Health</a></li>
                                            <li><a href="/tag/doctor">Doctor</a></li>
                                        </ul>
                                    </div>

                                    <div className="dc-widget dc-categories sidebar-box dc-sidebaradds dc-searchresultad clr">
                                        <img src="//css.meddylist.com//wp-content/uploads/2019/08/img-03-4.jpg" alt="" />
                                    </div>
                                </aside>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <style jsx>{`
                .dc-modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1000;
                }

                .dc-modal-content {
                    background: white;
                    padding: 30px;
                    border-radius: 12px;
                    width: 90%;
                    max-width: 700px;
                    max-height: 90vh;
                    overflow-y: auto;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.2);
                }

                .dc-modal-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 25px;
                    padding-bottom: 15px;
                    border-bottom: 1px solid #eee;
                }

                .dc-modal-close {
                    background: none;
                    border: none;
                    font-size: 1.5rem;
                    cursor: pointer;
                    color: #666;
                    transition: color 0.3s;
                }

                .dc-modal-close:hover {
                    color: #333;
                }

                .dc-review-form .dc-form-group {
                    margin-bottom: 20px;
                }

                .dc-review-form label {
                    font-weight: 500;
                    margin-bottom: 8px;
                    color: #333;
                    text-align: justify;
                }

                .dc-review-form .form-control {
                    border: 1px solid #ddd;
                    border-radius: 6px;
                    padding: 10px 15px;
                    transition: border-color 0.3s;
                }

                .dc-review-form .form-control:focus {
                    border-color: #007bff;
                    box-shadow: 0 0 0 0.2rem rgba(0,123,255,0.25);
                }

                .dc-rating-input {
                    display: flex;
                    align-items: center;
                    margin-top: 10px;
                    justify-content: center;
                }

                .dc-rating-input i {
                    transition: transform 0.2s;
                }

                .dc-rating-input i:hover {
                    transform: scale(1.2);
                }

                .dc-review-reply {
                    border-left: 3px solid #e9ecef;
                    padding-left: 20px;
                    margin-top: 20px;
                }

                .dc-btn {
                    padding: 8px 20px;
                    border-radius: 6px;
                    font-weight: 500;
                    transition: all 0.3s;
                }

                .dc-btn-primary {
                    background-color: #007bff;
                    border-color: #007bff;
                    font-weight: 600;
                }

                .dc-btn-primary:hover {
                    background-color: #0056b3;
                    border-color: #0056b3;
                }

                /* Specific style for Write a Review button */
                .dc-sectionhead .dc-btn-primary {
                    color: #ffffff !important;
                }

                .dc-sectionhead .dc-btn-primary:hover {
                    color: #ffffff !important;
                }

                .dc-btn-light {
                    background-color: #f8f9fa;
                    border-color: #ddd;
                    color: #333;
                }

                .dc-btn-light:hover {
                    background-color: #e2e6ea;
                    border-color: #ddd;
                }

                .dc-review-item {
                    border: 1px solid #eee;
                    border-radius: 8px;
                    transition: box-shadow 0.3s;
                }

                .dc-review-item:hover {
                    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                }

                .dc-reviewer-avatar i {
                    color: #007bff;
                }

                .dc-review-date {
                    font-size: 0.9rem;
                }

                .dc-review-content {
                    color: #444;
                    line-height: 1.6;
                }

                .dc-review-actions .dc-btn-link {
                    color: #007bff;
                    text-decoration: none;
                    padding: 0;
                }

                .dc-review-actions .dc-btn-link:hover {
                    color: #0056b3;
                    text-decoration: underline;
                }
            `}</style>
        </>
    );
};

export default ArticlesReviews;
